import { ButtonGroup, createStyles, Grid, IconButton, makeStyles, Theme, Typography } from "@material-ui/core";
import { List, Map } from "@material-ui/icons";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectCleverlynkGroup } from "../../redux/slices/cleverlynkSlice";
import CoverageList from "./CoverageList";
import CoverageMap from "./CoverageMap";
import { GeoSelectorStage } from "./GeoSelector";

enum CoverageSelectorStage {
  "MAP",
  "LIST",
}

interface ICoverageSelector {
  onConfirm: (id: string) => void;
}

const CoverageSelector = ({ onConfirm }: ICoverageSelector) => {
  const cleverlynkGroup = useSelector(selectCleverlynkGroup);

  const [stage, setStage] = useState<number>(CoverageSelectorStage.MAP);

  useEffect(() => {
    if (cleverlynkGroup?.openListFirst) setStage(CoverageSelectorStage.LIST);
  }, [cleverlynkGroup]);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      togglebuttongroup: {
        transition: "padding 200ms",
        "&.map": {
          marginBottom: -50,
          zIndex: 150,
          marginLeft: -5,
          paddingTop: 10,
          paddingRight: 5,
        },
        "&.list": {
          paddingTop: 5,
        },
      },
      togglebutton: {
        backgroundColor: "white",
        "&.Mui-selected": {
          backgroundColor: "#b3f7e3 !important",
        },
      },
    })
  );

  const classes = useStyles();

  const content = React.useMemo(() => {
    switch (stage) {
      case CoverageSelectorStage.MAP:
        return <CoverageMap onConfirm={onConfirm} />;

      case CoverageSelectorStage.LIST:
        return <CoverageList onConfirm={onConfirm} />;
      default:
        return null;
    }
  }, [stage]);

  return (
    <Grid container direction="column" style={{ marginTop: 5 }}>
      <Grid item container justifyContent="flex-end">
        <Grid item className={`${stage === CoverageSelectorStage.MAP ? "map" : "list"} ${classes.togglebuttongroup}`}>
          <ToggleButtonGroup
            exclusive
            size="small"
            value={stage}
            onChange={(_e, v) => (v !== null ? setStage(v) : null)}>
            <ToggleButton className={classes.togglebutton} value={CoverageSelectorStage.MAP}>
              <Map />
            </ToggleButton>
            <ToggleButton className={classes.togglebutton} value={CoverageSelectorStage.LIST}>
              <List />
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
      </Grid>
      {content}
    </Grid>
  );
};
export default CoverageSelector;
